export enum ANALYTICS_CATEGORY {
  CONTENT = 'content',
  MARKETING = 'marketing',
  PRODUCTS = 'products',
  AFFILIATES = 'affiliates',
  APPLICATION = 'application',
}
